export const long = {
  AmazonEC2: 'Elastic Compute Cloud',
  AmazonCloudFront: 'CloudFront',
  AWSCloudTrail: 'CloudTrail',
  AmazonCloudWatch: 'CloudWatch',
  AWSConfig: 'Config',
  AWSDataTransfer: 'Data Transfer',
  AWSDirectoryService: 'Directory Service',
  AmazonDynamoDB: 'DynamoDB',
  AmazonECR: 'EC2 Container Registry (ECR)',
  AmazonElastiCache: 'ElastiCache',
  AmazonES: 'Elasticsearch',
  awskms: 'Key Management Service',
  AmazonKinesis: 'Kinesis',
  AWSLambda: 'Lambda',
  AmazonRDS: 'RDS Service',
  AmazonRekognition: 'Rekognition',
  AmazonRedshift: 'Redshift',
  AmazonRoute53: 'Route 53',
  AmazonSES: 'Simple Email Service',
  AmazonSNS: 'Simple Notification Service',
  AWSQueueService: 'Simple Queue Service',
  AmazonS3: 'Simple Storage Service',
  AmazonSimpleDB: 'SimpleDB',
  AWSSupportDeveloper: 'Support (Developer)',
  AmazonVPC: 'Virtual Private Cloud',
  awswaf: 'WAF',
  AmazonWorkDocs: 'WorkDocs',
  AmazonCloudSearch: 'CloudSearch',
  _ACCOUNT_TAX: '徴収される消費税(日本)',
  _ACCOUNT_TOTAL: 'アカウント小計',
};

export const short = {
  AmazonEC2: 'EC2',
  AmazonRDS: 'RDS',
  AmazonElastiCache: 'ElastiCache',
};
